import React, { useContext, useEffect } from "react"
import { EditorInfoContext } from "../../../../../../../utis/userInfoContext"
import { getNormalizedDimensions, iframeBlurHeight, iframeBlurWidth, imageBlurHeight, imageBlurWidth, textBlurHeight, textBlurWidth } from "../../../../../../../utis/helper";

const PositionSection = ({ tool, handleChange, setTool, errorState, zoom }) => {
    const { editElement, setGeo, geo, pageDimensions  } = useContext(EditorInfoContext)

    const blurWidth = () => {
        
        let position = {
            width: tool?.geometry?.width,
            height: tool?.geometry?.height,
        };
        const max_Val = {
            max_Width: (pageDimensions?.width - Number(tool?.geometry?.left))
        }
        const keep_within_page = tool.geometry.keep_within_page;
        const keep_proportions = tool.geometry.keep_proportions;

        if (tool.element_type_name === "Image") {
            position = imageBlurWidth(position, max_Val, keep_within_page, keep_proportions, editElement?.geometry?.width);
        } else if (tool.element_type_name === "HTML Text") {
            position = textBlurWidth(position, max_Val, keep_proportions, editElement?.geometry?.width);
        } else if (tool.element_type_name === "Web URL") {
            position = iframeBlurWidth(position, max_Val, keep_proportions, editElement?.geometry?.width);
        }

        setTool({
            ...tool,
            geometry: {
                ...tool.geometry,
                height: position.height,
                width: position.width
            }
        });
         const node = document.getElementById(`div${editElement.id}`)
        if (node) {
            node.style.width = `${position.width}px`
                node.querySelectorAll('div').forEach(child => {
                if (child.style.width) {
                child.style.width = `${position.width}px`
                }
            })
        }
    }

    const blurHeight = () => {
        let position = {
            width: tool?.geometry?.width,
            height: tool?.geometry?.height,
        };
        const max_Val = {
            max_Width: (pageDimensions?.width - Number(tool?.geometry?.left)),
            max_Height: (pageDimensions?.height - Number(tool?.geometry?.top)),
        }
        const keep_within_page = tool.geometry?.keep_within_page;
        const keep_proportions = tool.geometry?.keep_proportions;

        if (tool.element_type_name === "Image") {
            position = imageBlurHeight(position, max_Val, keep_within_page, keep_proportions, editElement?.geometry?.height);
        } else if (tool.element_type_name === "HTML Text") {
            position = textBlurHeight(position, max_Val, keep_proportions, editElement?.geometry?.height);
        } else if (tool.element_type_name === "Web URL") {
            position = iframeBlurHeight(position, max_Val, keep_proportions, editElement?.geometry?.height);
        }

        setTool({
            ...tool,
            geometry: {
                ...tool.geometry,
                height: position.height,
                width: position.width
            }
        });
        const node = document.getElementById(`div${editElement.id}`)
        if (node) {
            node.style.height = `${position.height}px`
                node.querySelectorAll('div').forEach(child => {
                if (child.style.height) {
                child.style.height = `${position.height}px`
                }
            })
        }
    }
const drawTempRectOnPageCanvas = (geo) => {
  // Find canvas using tool.page as id
  const canvas = document.getElementById(tool.page);
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  // Clear previous drawings (just the temp overlay)
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Normalize dimensions (scale according to zoom + page size)
  const { geo: normalizedGeo } = getNormalizedDimensions(
    {...tool.geometry, geo:geo},
    1,
    pageDimensions,
    null,
    canvas
  );

  // Draw rectangle
  ctx.beginPath();
  ctx.lineWidth = 1;
  ctx.strokeStyle = "red";
  ctx.strokeRect(
    normalizedGeo.left,
    normalizedGeo.top,
    normalizedGeo.width,
    normalizedGeo.height
  );
  ctx.closePath();
};


    useEffect(() => {
        const currentDimensions = getNormalizedDimensions(tool?.geometry, zoom?.value, pageDimensions)
        setGeo(currentDimensions)
    }, [])

    return (
        <>
            <div className="position-section d-flex align-items-center justify-content-between">
                <label className="img-lab-clr">POSITION</label>
                <div className="d-flex position-left-right">
                    <div className="me-3 ">
                        Left: <input
                            type="number"
                            name="geometry.left"
                            value={tool?.geometry?.left}
                            onChange={(e) => {
                                handleChange(e)
                                const newLeft = Number(e.target.value)
                                setGeo({
                                    ...geo,
                                    left: newLeft,
                                });
                                const node = document.getElementById(`div${editElement.id}`)
                                if (node) {node.style.left = `${newLeft}px`}else {
  drawTempRectOnPageCanvas({ ...geo, left: newLeft });
}
                            }}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                    <div className="top-left-pop">
                        Top:  <input
                            type="number"
                            name="geometry.top"
                            value={tool?.geometry?.top}
                            onChange={(e) => {
                                handleChange(e)
                                const newTop = Number(e.target.value)
                                setGeo({
                                    ...geo,
                                    top: newTop,
                                });
                                const node = document.getElementById(`div${editElement.id}`)
                                if (node) {node.style.top = `${newTop}px`}else {
  drawTempRectOnPageCanvas({ ...geo, top: newTop });
}
                            }}
                            onFocus={(e) => e.target.select()}
                        />
                    </div>
                </div>
            </div>
            <div className="size-section d-flex justify-content-between align-items-center cursor-pointer">
                <label className="const-pro img-lab-clr" htmlFor="geometry.keep_proportions">
                   CONSTRAIN PROPORTIONS 
                    <input
                        id="geometry.keep_proportions"
                        type="checkbox"
                        name='geometry.keep_proportions'
                        value={tool?.geometry?.keep_proportions}
                        checked={tool?.geometry?.keep_proportions}
                        onChange={handleChange}
                    />
                </label>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center const-width">
                        <div>
                            Width:  <input
                                type="number"
                                name="geometry.width"
                                value={tool?.geometry?.width}
                                onChange={(e) => {
                                    handleChange(e)  
                                    const newWidth = Number(e.target.value)
                                    setGeo({ ...geo, width: newWidth })
                                    const wrapper = document.getElementById(`div${editElement.id}`)
                                    if (wrapper) {
                                        wrapper.style.width = `${newWidth}px`
                                        Array.from(wrapper.querySelectorAll('*')).forEach(el => {
                                            if (el.style && el.style.width) {
                                                el.style.width = `${newWidth}px`
                                            }
                                        })
                                    }else {
                                    drawTempRectOnPageCanvas({ ...geo, width: newWidth });
                                    }
                                }}
                                onFocus={(e) => e.target.select()}
                            />
                        </div>
                        <div>
                            Height:  <input
                                type="number"
                                name="geometry.height"
                                value={tool?.geometry?.height}
                                 onChange={(e) => {
                                    handleChange(e)
                                    const newHeight= Number(e.target.value)
                                    setGeo({ ...geo, height: newHeight })

                                    const wrapper = document.getElementById(`div${editElement.id}`)
                                    if (wrapper) {
                                        wrapper.style.height = `${newHeight}px`
                                        Array.from(wrapper.querySelectorAll('*')).forEach(el => {
                                            if (el.style && el.style.height) {
                                                el.style.height = `${newHeight}px`
                                            }
                                        })
                                    } else {
                                                drawTempRectOnPageCanvas({ ...geo, height: newHeight });
                                        }
                                }}
                                onFocus={(e) => e.target.select()}
                            />
                        </div>
                    </div>
                    <p className="text-danger">{errorState?.dimensionError}</p>
                </div>
            </div>
        </>
    )
}
export default PositionSection